<template>
  <!-- <div> -->
  <button
    v-if="
      (stickyBuynowButton && smallScreen && oneVariant) ||
      (stickyBuynowButton && !smallScreen && (oneVariant || !oneVariant)) ||
      !stickyBuynowButton
    "
    class="cta cta--light"
    id="mikmak-button"
    :data-mm-ids="productId"
    :data-mm-wtbid="mikmakWidgetId"
    :data-mm-sticky="mikmakStickyButton"
    v-bind="additionalProp"
    :aria-label="labelText"
    data-mm-id-type="gtin"
    @click="handleBuyNowClick(productName, productId)"
  >
    <span>{{ labelText }}</span>
  </button>
  <!-- <ddx-widget/> -->

  <!-- </div> -->
</template>

<script>
import { AnalyticsHandler } from '@Foundation/analyticsHandler';
//import DdxWidget from '@Feature/DDX/code/Scripts/components/ddx.vue';

export default {
  name: 'mikmak-module',
  // components: { DdxWidget },
  data() {
    return {
      smallScreen: !window.matchMedia('(min-width: 1024px)').matches,
      filteredProducts: [],
      variantSize:'',
    };
  },
  props: {
    mikmakWidgetId: {
      type: String,
      required: false,
    },
    mikmakStickyButton: {
      type: Boolean,
      required: false,
    },
    labelText: {
      type: String,
      default: 'BUY NOW',
    },
    productId: {
      type: String,
      required: false,
    },
    analyticsData: {
      type: Object,
      default: () => ({}),
    },
    stickyBuynowButton: { type: Boolean, required: false, default: false },
    oneVariant: { type: Boolean, required: false, default: false },
    isDdxVisible: false,
    mikmakCartTag: {
      type: Array,
      required: false,
      default: () => [],
    },
    productName: { type: String, required: false, default: '' },

  },
  computed: {
    additionalProp() {
      return this.mikmakStickyButton ? { 'data-mm-main-id': this.productId } : {};
    },
  },
  mounted() {
    if (!window.swnDataLayer) window.swnDataLayer = {};
    window.swnDataLayer.widget_callback = this.handleMikMakEvents;

    window.eventBus.$on('selectedVolume', (payload) => {
      this.$emit('update:productId', payload);
      this.variantSize = payload.size;
    });
  },
  methods: {
    // ddxOn(){
    //   window.eventBus.$emit('mikmakOpened');
    // },
    handleMikMakEvents(event) {      
      if (event.action === 'buy') this.addToCart(event);
    },
    addToCart(event) {
      if (!Array.isArray(this.mikmakCartTag) || this.mikmakCartTag.length === 0) {
        return;
      }
      const cleanProductId =  event.product.id.split('_')[0];
      let productData = window.eventBus.mikmakproduct;

      productData.forEach(tag => {
          if (tag.variantEANId === cleanProductId) {
            tag?.tagging?.ecommerce?.detail?.products.forEach(product => {
               if (this.variantSize){
                product.dimension35 = this.variantSize;
                product.variant = this.variantSize;
               }
               this.filteredProducts = product;
            });
          }
        });
      try {
        window.dataLayer.push({
          event: 'addToCart',
          event_name: 'add_to_cart',
          eventCategory: 'Ecommerce',
          eventAction: `redirection::${event.store.name.toLowerCase()}`,
          eventLabel: `${event.product.name.toLowerCase()}::${cleanProductId}`,
          product_info: `${event.product.name.toLowerCase()}::${cleanProductId}`,
          step: 'redirection',
          store_name: event.store.name.toLowerCase(),
          ecommerce: {
            currencyCode: event.product.currency,
            add: {
              products: this.filteredProducts, 
            },
          },
        });
      } catch (error) {
        console.error( error);
      }

    },
    storeCurrentProduct() {
        window.eventBus.mikmakproduct = this.mikmakCartTag;
    },
    handleBuyNowClick(productName, productId) {
      this.storeCurrentProduct(); 
      this.$nextTick(() => { 
        this.triggerAnalytics(productName, productId);
      });
    },
    triggerAnalytics(productName,productId) {
     try {      
      window.dataLayer.push({
        event: "uaevent",
        event_name: "buy_now",
        ecommerce: "undefined",
        eventCategory: "Ecommerce",
        eventAction: "click to buy",
        eventLabel: `${productName.toLowerCase()}::${productId}`,
        product_info: `${productName.toLowerCase()}::${productId}`,
      });
      } catch (error) {
        console.error("Error in triggerAnalytics:", error);
      }
    }
  },
};
</script>
<style lang="scss" src="./mikmak-module.scss"></style>
